import * as React from 'react';
import './ProjectLookupsLayout.scss';
import { connect } from "react-redux";
import { RestrictedLayout } from "../../../components/layouts/index";
import { ITmdState } from "../../../reducers/index";
import * as Dtos from '../../../dtos/Tmd.dtos';
import { SettingsSubMenu } from '../../../helpers/subMenuHelper';
import * as AuthenticationHelper from '../../../helpers/authentication';
import { FontAwesomeIcon, FontAwesomeIcons } from "../../../constants/fontAwesomeIcons";

interface IProjectLookupsLayoutProps {
    permissions?: Dtos.PersonnelTmdPermissions[];
    permission?: Dtos.Permission;
    loading?: boolean;
    children?: any;
}

interface IProjectLookupsLayoutActions {

}

type ProjectLookupsLayoutProps = IProjectLookupsLayoutProps & IProjectLookupsLayoutActions;

class ProjectLookupsLayout extends React.PureComponent<ProjectLookupsLayoutProps, any> {

    constructor(props: ProjectLookupsLayoutProps) {
        super(props);

    }

    render() {
        const {
            loading,
            permissions,
            permission
        } = this.props;

        let menu: any = []; 
        if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.ProjectItemTemplatesView)) {
            menu.push({
                icon: undefined,
                title: "Item Templates",
                url: "/settings/project/itemtemplates"
            });
        }
        if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.ProjectItemComponentsView)) {
            menu.push({
                icon: undefined,
                title: "Item Components",
                url: "/settings/project/itemcomponents"
            });
        }
        if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.ProjectItemCategoriesView)) {
            menu.push({
                icon: undefined,
                title: "Item Categories",
                url: "/settings/project/itemcategories"
            });
        }

        return <RestrictedLayout
            subMenuItems={loading ? [] : SettingsSubMenu(permissions)}
            sub2MenuItems={loading ? [] : menu}
            loading={loading}
        >
            {permissions.length > 0 && permission && !AuthenticationHelper.hasPermission(permissions, permission) ?
                <div className="alert alert-warning d-flex">
                    <div className="mr-2">
                        <FontAwesomeIcon icon={FontAwesomeIcons.Solid.INFO_SQUARE} fixedWidth />
                    </div>
                    <span>Permission Denied</span>
                </div>
                : this.props.children}
        </RestrictedLayout>;
    }

}


const mapStateToProps = (state: ITmdState, ownProps: ProjectLookupsLayoutProps): IProjectLookupsLayoutProps => {
    let permissions = state.user.userSummary ? state.user.userSummary.permissions : [];
    return {
        permissions: permissions,
        permission: ownProps.permission,
        loading: ownProps.loading,
        children: ownProps.children
    };
};

const mapDispatchToProps = (dispatch): IProjectLookupsLayoutActions => {
    return {
        
    };
};

export default
    connect(mapStateToProps, mapDispatchToProps)(ProjectLookupsLayout);
